export interface DaysSelectorOption<T extends string | number> {
  value: T;
  label: string;
}

interface DaysSelectorProps<T extends string | number> {
  options: DaysSelectorOption<T>[];
  selected: T | null;
  onSelect: (value: T) => void;
  className?: string;
}

/**
 * Standard segmented day-range selector: gray pill container with a white
 * (shadowed) segment for the active option, e.g. 15d | 30d | 45d | 60d | 90d.
 */
function DaysSelector<T extends string | number>({
  options,
  selected,
  onSelect,
  className = "",
}: DaysSelectorProps<T>) {
  return (
    <div
      className={`flex items-center gap-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1 ${className}`}
    >
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onSelect(option.value)}
          className={`px-3 py-2.5 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${
            selected === option.value
              ? "bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm"
              : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default DaysSelector;
